<template>
  <v-dialog :model-value="isOpen" width="440" v-on:keydown.stop persistent>
    <template v-slot:activator="{ props }">
      <slot name="activator" :props="props"></slot>
    </template>

    <div class="dialog">
      <div class="d-flex mb-6">
        <v-icon size="large" class="mr-3 mt-3" style="margin-top: 2px;">mds:info</v-icon>
        <span class="text-title mr-3 mt-3 text-truncate">{{ title || 'Important' }}</span>
        <v-spacer/>
        <v-btn variant="text" color="grey" @click="close" icon="mdi-close">
        </v-btn>
      </div>

      <div class="mb-6">
        {{ message }}
      </div>

      <div class="d-flex">
        <v-spacer/>
        <slot name="footer">
          <v-btn variant="flat" size="large" @click="close">
            I understand
          </v-btn>
        </slot>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'info-message-dialog',
  props: {
    title: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #FCFCFC;
  background: #FCFCFC;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
}
</style>
